import { defineComponent as _defineComponent } from 'vue'
import { EntityColourType } from '@/lib/enum/Colour';
import { Sizes, SizesType } from '@/lib/enum/size/Sizes';


export default /*#__PURE__*/_defineComponent({
  __name: 'LabelWithColour',
  props: {
    colour: null,
    icon: { default: '' },
    label: null,
    colourSize: { default: Sizes.Small },
    wrapText: { type: Boolean, default: true }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})